import React from "react";
import { makeStyles } from "@material-ui/core";
import { useSpring, animated, config } from "react-spring";

import { ACHETER, REPARER, REPRISE, ENGAGEMENTS } from "./TopHeader";
import ReconditionnePanelContent from "../subHeader/reconditionneSubHeader/expandablePanel/SubPanelContent";

function HoverHeader({ hovered, productTypes, commercialCategories }) {
  const classes = useStyle();

  const { transform } = useSpring({
    transform: `translateY(${hovered === ACHETER ? 0 : -300}px) `,
    config: config.stiff,
  });
  function renderPanel() {
    if (hovered === ACHETER || !hovered) {
      return (
        <div className={classes.inner}>
          <animated.div style={{ transform }}>
            <ReconditionnePanelContent productTypes={productTypes} commercialCategories={commercialCategories} />
          </animated.div>
        </div>
      );
    }
    if (hovered === REPARER) {
      return null;
    }
    if (hovered === REPRISE) {
      return null;
    }
    if (hovered === ENGAGEMENTS) {
      return null;
    }
    return null;
  }
  if (!hovered) {
    return null;
  }
  return <div className={classes.container}>{renderPanel()}</div>;
}

const useStyle = makeStyles((theme) => ({
  container: {
    position: "absolute",
    zIndex: -1,
    width: "100%",
    boxShadow: "0px 1px #e6e6e6",
  },
  categoryTitle: {
    fontWeight: 700,
    fontSize: 19,
  },
  product: {
    marginTop: theme.spacing(2),
  },
  inner: {
    paddingTop: 70,
    background: "white",
    paddingBottom: 100,
  },
}));

export default HoverHeader;
